import { entityTypes, entityTypesEnum } from "helpers/enums";
import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";

const config = {
    displayName: {
        // field
        label: "Название",
        inputProps: { name: "displayName" },
        required: true,
        validators: [requiredField],
    },
    description: {
        // field
        label: "Описание",
        inputProps: { name: "description" },
    },
    externalId: {
        // field
        label: "Идентификатор",
        inputProps: { name: "externalId" },
        required: true,
        validators: [requiredField],
    },
    entityType: {
        // select
        label: "Тип сущности",
        inputProps: { name: "entityType" },
        required: true,
        options: entityTypes.filter((item) =>
            [entityTypesEnum.Cargo, entityTypesEnum.TruckingBid, entityTypesEnum.BidPoint].includes(item.value),
        ),
        validators: [requiredField],
    },
    entityOptionId: {},
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
